import React from 'react';
import { MoonIcon } from 'lucide-react';
import { TornEdge } from './TornEdge';
import { contact } from '../data/contact';
interface FooterProps {
  lockup: string;
}
const navLinks = [{
  href: '#inicio',
  label: 'Inicio'
}, {
  href: '#servicios',
  label: 'Prácticas'
}, {
  href: '#videollamada',
  label: 'Videollamada'
}, {
  href: '#contacto',
  label: 'Contacto'
}, {
  href: '#politicas',
  label: 'Políticas del sitio'
}];
export function Footer({
  lockup
}: FooterProps) {
  return <footer className="relative bg-ink pb-16 pt-16" data-id="element-49" data-mp="38h3r5ed5aiu">
      <TornEdge colorClassName="bg-ink" data-id="element-50" data-mp="37xyao5wgelp" />
      <div className="relative mx-auto w-full max-w-6xl px-5 sm:px-8" data-id="element-51" data-mp="3lem0a55nkln5">
        <div className="flex flex-col gap-10 lg:flex-row lg:items-start lg:justify-between" data-id="element-52" data-mp="3lggbgrr4gze1">
          <div className="max-w-md" data-id="element-53" data-mp="3qfjj8jyhljpp">
            <div className="flex items-center gap-3" data-id="element-54" data-mp="29ynnbq7ctfgn">
              <MoonIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-55" data-mp="29xvqkc20tbos" />
              <span className="font-display text-[0.66rem] font-medium uppercase tracking-[0.26em] text-paper sm:text-[0.8rem]" data-id="element-56" data-mp="2ez1lmgj5lb1h">
                {lockup}
              </span>
            </div>
            <p className="mt-5 text-sm leading-relaxed text-body/80" data-id="element-57" data-mp="3gbimaqsivm1a">
              Templo de Ayuda Espiritual. Consultas, rituales y orientación
              espiritual de carácter tradicional y personalizado.
            </p>
          </div>

          <div className="grid gap-8 sm:grid-cols-2 lg:gap-14" data-id="element-58" data-mp="3qazqt4w1ftvo">
            <div data-id="element-59" data-mp="81pejgi0et8b">
              <h2 className="font-folio text-[0.62rem] uppercase tracking-[0.24em] text-gold" data-id="element-60" data-mp="817e07obdsul">
                Navegación
              </h2>
              <ul className="mt-4 space-y-3 text-sm text-body" data-id="element-61" data-mp="hsk0skv99str">
                {navLinks.map(link => <li key={link.href} data-id="element-62" data-mp="ct78vlpj1vkb">
                    <a href={link.href} className="transition-colors hover:text-gold focus:outline-none focus-visible:ring-2 focus-visible:ring-gold" data-id="element-63" data-mp="cuil89x1gbn1">
                      {link.label}
                    </a>
                  </li>)}
              </ul>
            </div>
            <div data-id="element-64" data-mp="yto901jxadwu">
              <h2 className="font-folio text-[0.62rem] uppercase tracking-[0.24em] text-gold" data-id="element-65" data-mp="yv93xsa5fyv8">
                Contacto
              </h2>
              <ul className="mt-4 space-y-3 text-sm text-body" data-id="element-66" data-mp="13r7mv0cpkoo9">
                <li data-id="element-67" data-mp="18l2csliwpzvs">
                  <a href={contact.whatsappHref} target="_blank" rel="noreferrer" className="transition-colors hover:text-gold" data-id="element-68" data-mp="18lbulltst0qe">
                    WhatsApp {contact.whatsapp}
                  </a>
                </li>
                <li data-id="element-69" data-mp="1mhpfz61gdma5">
                  <a href={contact.phoneHref} className="transition-colors hover:text-gold" data-id="element-70" data-mp="1rilfz8ioooaa">
                    {contact.phone}
                  </a>
                </li>
                <li data-id="element-71" data-mp="3tb9mbqqmjrua">
                  <a href={contact.emailHref} className="break-all transition-colors hover:text-gold" data-id="element-72" data-mp="3tarquwbsdhnf">
                    {contact.email}
                  </a>
                </li>
                <li className="text-body/80" data-id="element-73" data-mp="21mti67s7uw1u">{contact.address}</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-14 border-t border-gold/25 pt-7" data-id="element-74" data-mp="1woi93z9qwpko">
          <p className="text-xs leading-relaxed text-body/60" data-id="element-75" data-mp="2tdzk8trhz3tr">
            Sitio dirigido exclusivamente a personas mayores de edad. Consultas y
            prácticas de carácter espiritual y tradicional. Consulta nuestros{' '}
            <a href="#terminos" className="underline hover:text-gold" data-id="element-76" data-mp="2kci8top1bqbe">
              términos y condiciones
            </a>{' '}
            y nuestra{' '}
            <a href="#privacidad" className="underline hover:text-gold" data-id="element-77" data-mp="2fgb39x0jwgtz">
              política de privacidad
            </a>
            .
          </p>
          <p className="mt-4 font-folio text-[0.62rem] uppercase tracking-[0.18em] text-body/50" data-id="element-78" data-mp="13y058w176k67">
            © {new Date().getFullYear()} {contact.brandName}. Todos los derechos
            reservados.
          </p>
        </div>
      </div>
    </footer>;
}